module.exports = __webpack_public_path__ + "static/img/16.15040ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/16.png
// module id = NHy3
// module chunks = 0